import { memo } from 'react';
import { Path as _Path, Rect as _Rect, Svg as _Svg } from 'react-native-svg';
import { themed } from './themed';

const Icon = (props) => {
  const { color, size, colorLight } = props;
  return (
    <_Svg
      height={size}
      width={size}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <_Path
        d="M10 13C9.44444 13 8.97222 12.8104 8.58333 12.4312C8.19444 12.0521 8 11.5917 8 11.05C8 10.9742 8.00556 10.8956 8.01667 10.8144C8.02778 10.7331 8.04445 10.66 8.06667 10.595L3.36667 7.93C3.17778 8.0925 2.96667 8.21979 2.73333 8.31188C2.5 8.40396 2.25556 8.45 2 8.45C1.44444 8.45 0.972222 8.26042 0.583333 7.88125C0.194444 7.50208 0 7.04167 0 6.5C0 5.95833 0.194444 5.49792 0.583333 5.11875C0.972222 4.73958 1.44444 4.55 2 4.55C2.25556 4.55 2.5 4.59604 2.73333 4.68812C2.96667 4.78021 3.17778 4.9075 3.36667 5.07L8.06667 2.405C8.04445 2.34 8.02778 2.26687 8.01667 2.18562C8.00556 2.10437 8 2.02583 8 1.95C8 1.40833 8.19444 0.947917 8.58333 0.56875C8.97222 0.189583 9.44444 0 10 0C10.5556 0 11.0278 0.189583 11.4167 0.56875C11.8056 0.947917 12 1.40833 12 1.95C12 2.49167 11.8056 2.95208 11.4167 3.33125C11.0278 3.71042 10.5556 3.9 10 3.9C9.74444 3.9 9.5 3.85396 9.26667 3.76187C9.03333 3.66979 8.82222 3.5425 8.63333 3.38L3.93333 6.045C3.95556 6.11 3.97222 6.18312 3.98333 6.26437C3.99444 6.34562 4 6.42417 4 6.5C4 6.57583 3.99444 6.65438 3.98333 6.73562C3.97222 6.81687 3.95556 6.89 3.93333 6.955L8.63333 9.62C8.82222 9.4575 9.03333 9.33021 9.26667 9.23812C9.5 9.14604 9.74444 9.1 10 9.1C10.5556 9.1 11.0278 9.28958 11.4167 9.66875C11.8056 10.0479 12 10.5083 12 11.05C12 11.5917 11.8056 12.0521 11.4167 12.4312C11.0278 12.8104 10.5556 13 10 13Z"
        fill={color}
      />
    </_Svg>
  );
};
Icon.displayName = 'ShareSolidRegular';
const ShareSolidRegular = memo(themed(Icon));
export { ShareSolidRegular };
